(function() {
    'use strict';

    var DEFAULT_AGENCE_POSITION = { lat: 48.8582846, lon: 2.2944474 };
    var DEFAULT_ZOOM = 10;
    var READONLY_ZOOM = 16;
    var GEOMETRY_PATH_COLOR = '#2e3974';
    var GEOMETRY_HOLE_COLOR = '#6f7d8c';

    var mapLeaflet = {
        bindings: {
            contrat: '=',
            readonly: '@',
            geometry: '=?',
            geometryEditable: '@',
            refreshToken: '<?',
            height: '@',
            width: '@'
        },
        templateUrl: 'app/components/map-leaflet/map-leaflet.tpl.html',
        controller: mapLeafletController
    };

    mapLeafletController.$inject = ['$scope', '$attrs', '$timeout', 'Principal', 'leafletData'];

    function mapLeafletController($scope, $attrs, $timeout, Principal, leafletData) {
        var ctrl = this;
        var hasExplicitGeometryBinding = angular.isDefined($attrs.geometry);

        ctrl.markerEditMode = false;
        ctrl.geometryEditMode = false;
        ctrl.geometryPointCreationMode = false;
        ctrl.activeGeometryRing = null;
        ctrl.isReadonly = isReadonly;
        ctrl.hasGeometryEditor = hasGeometryEditor;
        ctrl.toggleGeometryEditMode = toggleGeometryEditMode;
        ctrl.toggleGeometryPointCreationMode = toggleGeometryPointCreationMode;
        ctrl.clearGeometry = clearGeometry;
        ctrl.updateCoord = updateCoord;
        ctrl.mapId = 'map_leaflet_' + Math.floor(Math.random() * 1000000000);

        angular.extend($scope, {
            center: {},
            bounds: {},
            markers: {},
            defaults: {},
            paths: {},
            layers: {
                baselayers: {
                    osm: {
                        name: 'OpenStreetMap',
                        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        type: 'xyz'
                    },
                    satelite: {
                        name: 'Satelite',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                        type: 'xyz'
                    }
                }
            },
            events: {
                map: {
                    enable: ['click', 'contextmenu'],
                    logic: 'emit'
                }
            }
        });

        ctrl.$onInit = function() {
            refreshMap();
            scheduleInvalidateMapSize(4);
        };

        function hasCoordValue(value) {
            return value !== null && value !== undefined && value !== '';
        }

        function hasCoordinates() {
            return ctrl.contrat && hasCoordValue(ctrl.contrat.lat) && hasCoordValue(ctrl.contrat.lon);
        }

        function getMarkerLabel() {
            if (!ctrl.contrat) {
                return '';
            }
            return ctrl.contrat.referenceContrat || ctrl.contrat.numeroSerie || ctrl.contrat.nom || '';
        }

        function isReadonly() {
            return ctrl.readonly === true || ctrl.readonly === 'true';
        }

        function hasGeometryEditor() {
            return ctrl.geometryEditable === true || ctrl.geometryEditable === 'true';
        }

        function getGeometryValue() {
            if (hasExplicitGeometryBinding) {
                return ctrl.geometry;
            }
            return ctrl.contrat ? ctrl.contrat.geographicCoord : null;
        }

        function setGeometryValue(value) {
            if (hasExplicitGeometryBinding) {
                ctrl.geometry = value;
            } else if (ctrl.contrat) {
                ctrl.contrat.geographicCoord = value;
            }
        }

        function buildMarkerState() {
            var markers = {};

            if (hasCoordinates()) {
                var markerLabel = getMarkerLabel();
                markers.contrat = {
                    lat: ctrl.contrat.lat,
                    lng: ctrl.contrat.lon,
                    message: (markerLabel ? markerLabel + '<br/> ' : '') + '@' + ctrl.contrat.lat + ',' + ctrl.contrat.lon,
                    draggable: !isReadonly() && ctrl.markerEditMode
                };
            }

            return markers;
        }

        function refreshMap() {
            var geometryState = buildGeometryState();
            var markers = buildMarkerState();

            angular.extend(markers, geometryState.markers);

            angular.extend($scope, {
                defaults: {
                    scrollWheelZoom: false
                },
                markers: markers,
                paths: geometryState.paths,
                bounds: geometryState.bounds
            });

            refreshCenter(geometryState.bounds);
            scheduleInvalidateMapSize(1);
        }

        function scheduleInvalidateMapSize(retryCount) {
            $timeout(function() {
                leafletData.getMap(ctrl.mapId).then(function(map) {
                    if (!map || !map.invalidateSize) {
                        return;
                    }

                    map.invalidateSize(false);

                    if (retryCount > 0) {
                        scheduleInvalidateMapSize(retryCount - 1);
                    }
                }, angular.noop);
            }, 150, false);
        }

        function refreshCenter(boundsOverride) {
            var bounds = boundsOverride || buildGeometryState().bounds;

            if (bounds && bounds.southWest && bounds.northEast) {
                angular.extend($scope, {
                    center: {
                        lat: (bounds.southWest.lat + bounds.northEast.lat) / 2,
                        lng: (bounds.southWest.lng + bounds.northEast.lng) / 2,
                        zoom: isReadonly() ? READONLY_ZOOM : DEFAULT_ZOOM
                    }
                });
                return;
            }

            if (hasCoordinates()) {
                angular.extend($scope, {
                    center: {
                        lat: ctrl.contrat.lat,
                        lng: ctrl.contrat.lon,
                        zoom: isReadonly() ? READONLY_ZOOM : DEFAULT_ZOOM
                    }
                });
                return;
            }

            angular.extend($scope, {
                center: {
                    lat: DEFAULT_AGENCE_POSITION.lat,
                    lng: DEFAULT_AGENCE_POSITION.lon,
                    zoom: 5
                }
            });
        }

        function buildGeometryState() {
            var geometryData = parseGeometryValue(getGeometryValue());
            var paths = {};
            var markers = {};
            var bounds = emptyBounds();

            if (!geometryData || !geometryData.geometry || !angular.isArray(geometryData.geometry.coordinates)) {
                return {
                    paths: paths,
                    markers: markers,
                    bounds: null
                };
            }

            angular.forEach(geometryData.geometry.coordinates, function(polygon, polygonIndex) {
                if (!angular.isArray(polygon)) {
                    return;
                }

                angular.forEach(polygon, function(ring, ringIndex) {
                    if (!angular.isArray(ring) || !ring.length) {
                        return;
                    }

                    var ringLatLngs = [];
                    var uniqueRingCoordinates = getUniqueRingCoordinates(ring);

                    angular.forEach(ring, function(point) {
                        if (!isValidCoordinate(point)) {
                            return;
                        }

                        ringLatLngs.push({
                            lat: point[1],
                            lng: point[0]
                        });
                        extendBounds(bounds, point[1], point[0]);
                    });

                    if (ringLatLngs.length >= 3) {
                        // On garde un rendu simple par anneau pour rester compatible avec l'existant ui-leaflet.
                        paths['geometry_' + polygonIndex + '_' + ringIndex] = {
                            color: ringIndex === 0 ? GEOMETRY_PATH_COLOR : GEOMETRY_HOLE_COLOR,
                            fillColor: ringIndex === 0 ? GEOMETRY_PATH_COLOR : GEOMETRY_HOLE_COLOR,
                            fillOpacity: ringIndex === 0 ? 0.15 : 0.08,
                            weight: ringIndex === 0 ? 3 : 2,
                            type: 'polygon',
                            latlngs: ringLatLngs
                        };
                    }

                    if (hasGeometryEditor()) {
                        angular.forEach(uniqueRingCoordinates, function(point, pointIndex) {
                            markers[getVertexMarkerName(polygonIndex, ringIndex, pointIndex)] = {
                                lat: point[1],
                                lng: point[0],
                                draggable: ctrl.geometryEditMode,
                                riseOnHover: true
                            };
                        });
                    }
                });
            });

            return {
                paths: paths,
                markers: markers,
                bounds: bounds.isEmpty ? null : {
                    southWest: {
                        lat: bounds.minLat,
                        lng: bounds.minLng
                    },
                    northEast: {
                        lat: bounds.maxLat,
                        lng: bounds.maxLng
                    }
                }
            };
        }

        function emptyBounds() {
            return {
                minLat: null,
                maxLat: null,
                minLng: null,
                maxLng: null,
                isEmpty: true
            };
        }

        function extendBounds(bounds, lat, lng) {
            if (!bounds) {
                return;
            }

            if (bounds.isEmpty) {
                bounds.minLat = lat;
                bounds.maxLat = lat;
                bounds.minLng = lng;
                bounds.maxLng = lng;
                bounds.isEmpty = false;
                return;
            }

            bounds.minLat = Math.min(bounds.minLat, lat);
            bounds.maxLat = Math.max(bounds.maxLat, lat);
            bounds.minLng = Math.min(bounds.minLng, lng);
            bounds.maxLng = Math.max(bounds.maxLng, lng);
        }

        function parseGeometryValue(geometryValue) {
            if (!geometryValue) {
                return null;
            }

            try {
                return angular.fromJson(geometryValue);
            } catch (error) {
                return null;
            }
        }

        function isValidCoordinate(point) {
            return angular.isArray(point) && point.length >= 2 && angular.isNumber(point[0]) && angular.isNumber(point[1]);
        }

        function getVertexMarkerName(polygonIndex, ringIndex, pointIndex) {
            return ['geometryVertex', polygonIndex, ringIndex, pointIndex].join('_');
        }

        function parseVertexMarkerName(markerName) {
            if (!markerName || markerName.indexOf('geometryVertex_') !== 0) {
                return null;
            }

            var parts = markerName.split('_');
            if (parts.length !== 4) {
                return null;
            }

            return {
                polygonIndex: parseInt(parts[1], 10),
                ringIndex: parseInt(parts[2], 10),
                pointIndex: parseInt(parts[3], 10)
            };
        }

        function getUniqueRingCoordinates(ring) {
            var uniqueCoordinates = angular.copy(ring || []);

            if (uniqueCoordinates.length > 1 && isSameCoordinate(uniqueCoordinates[0], uniqueCoordinates[uniqueCoordinates.length - 1])) {
                uniqueCoordinates.pop();
            }

            return uniqueCoordinates;
        }

        function isSameCoordinate(firstPoint, secondPoint) {
            return isValidCoordinate(firstPoint) && isValidCoordinate(secondPoint)
                && firstPoint[0] === secondPoint[0]
                && firstPoint[1] === secondPoint[1];
        }

        function ensureGeometryObject() {
            var geometryData = parseGeometryValue(getGeometryValue());

            // On force toujours une structure Elastic MultiPolygon minimale pour pouvoir éditer la géométrie.
            if (!geometryData || !geometryData.geometry || geometryData.geometry.type !== 'MultiPolygon' || !angular.isArray(geometryData.geometry.coordinates)) {
                geometryData = {
                    geometry: {
                        type: 'MultiPolygon',
                        coordinates: [
                            [
                                []
                            ]
                        ]
                    }
                };
            }

            if (!geometryData.geometry.coordinates.length) {
                geometryData.geometry.coordinates.push([[]]);
            }

            if (!geometryData.geometry.coordinates[0].length) {
                geometryData.geometry.coordinates[0].push([]);
            }

            return geometryData;
        }

        function ensureGeometryRing(geometryData, polygonIndex, ringIndex) {
            while (geometryData.geometry.coordinates.length <= polygonIndex) {
                geometryData.geometry.coordinates.push([[]]);
            }

            while (geometryData.geometry.coordinates[polygonIndex].length <= ringIndex) {
                geometryData.geometry.coordinates[polygonIndex].push([]);
            }
        }

        function closeRing(uniqueCoordinates) {
            var closedRing = angular.copy(uniqueCoordinates || []);

            // Le backend attend un anneau fermé : on duplique le premier point en fin de tableau dès que le polygone est dessinable.
            if (closedRing.length >= 3) {
                closedRing.push(angular.copy(closedRing[0]));
            }

            return closedRing;
        }

        function saveGeometryObject(geometryData) {
            setGeometryValue(angular.toJson(geometryData, true));
            refreshMap();
        }

        function updateEditableRing(uniqueCoordinates, polygonIndex, ringIndex) {
            var geometryData = ensureGeometryObject();
            var safePolygonIndex = angular.isNumber(polygonIndex) ? polygonIndex : 0;
            var safeRingIndex = angular.isNumber(ringIndex) ? ringIndex : 0;

            ensureGeometryRing(geometryData, safePolygonIndex, safeRingIndex);
            geometryData.geometry.coordinates[safePolygonIndex][safeRingIndex] = closeRing(uniqueCoordinates);
            saveGeometryObject(geometryData);
        }

        function getEditableRingUniqueCoordinates(polygonIndex, ringIndex) {
            var geometryData = ensureGeometryObject();
            var safePolygonIndex = angular.isNumber(polygonIndex) ? polygonIndex : 0;
            var safeRingIndex = angular.isNumber(ringIndex) ? ringIndex : 0;

            ensureGeometryRing(geometryData, safePolygonIndex, safeRingIndex);
            return getUniqueRingCoordinates(geometryData.geometry.coordinates[safePolygonIndex][safeRingIndex]);
        }

        function toggleGeometryEditMode() {
            if (!hasGeometryEditor()) {
                return;
            }

            ctrl.geometryEditMode = !ctrl.geometryEditMode;
            refreshMap();
        }

        function toggleGeometryPointCreationMode() {
            if (!hasGeometryEditor()) {
                return;
            }

            ctrl.geometryPointCreationMode = !ctrl.geometryPointCreationMode;
        }

        function clearGeometry() {
            if (!hasGeometryEditor()) {
                return;
            }

            ctrl.geometryEditMode = false;
            ctrl.geometryPointCreationMode = false;
            ctrl.activeGeometryRing = null;
            setGeometryValue(null);
            refreshMap();
        }

        function getActiveGeometryRing() {
            if (ctrl.activeGeometryRing) {
                return ctrl.activeGeometryRing;
            }

            return {
                polygonIndex: 0,
                ringIndex: 0
            };
        }

        function addGeometryPoint(latlng) {
            var activeRing;
            if (!latlng) {
                return;
            }

            activeRing = getActiveGeometryRing();

            var uniqueCoordinates = getEditableRingUniqueCoordinates(activeRing.polygonIndex, activeRing.ringIndex);
            uniqueCoordinates.push([latlng.lng, latlng.lat]);
            updateEditableRing(uniqueCoordinates, activeRing.polygonIndex, activeRing.ringIndex);
        }

        function updateGeometryPoint(markerName, latlng) {
            var markerMetadata = parseVertexMarkerName(markerName);
            var geometryData;
            var uniqueCoordinates;

            if (!markerMetadata || !latlng) {
                return;
            }

            geometryData = ensureGeometryObject();

            if (!geometryData.geometry.coordinates[markerMetadata.polygonIndex]
                || !geometryData.geometry.coordinates[markerMetadata.polygonIndex][markerMetadata.ringIndex]) {
                return;
            }

            uniqueCoordinates = getUniqueRingCoordinates(geometryData.geometry.coordinates[markerMetadata.polygonIndex][markerMetadata.ringIndex]);

            if (!uniqueCoordinates[markerMetadata.pointIndex]) {
                return;
            }

            ctrl.activeGeometryRing = {
                polygonIndex: markerMetadata.polygonIndex,
                ringIndex: markerMetadata.ringIndex
            };
            uniqueCoordinates[markerMetadata.pointIndex] = [latlng.lng, latlng.lat];
            geometryData.geometry.coordinates[markerMetadata.polygonIndex][markerMetadata.ringIndex] = closeRing(uniqueCoordinates);
            saveGeometryObject(geometryData);
        }

        function updateCoord() {
            refreshMap();
        }

        function getMapScopedLeafletEventName(eventName) {
            var firstSeparatorIndex = eventName.indexOf('.');

            if (!ctrl.mapId || firstSeparatorIndex === -1) {
                return eventName;
            }

            return eventName.substring(0, firstSeparatorIndex) + '.' + ctrl.mapId + eventName.substring(firstSeparatorIndex);
        }

        function listenLeafletEvent(eventName, handler) {
            var scopedEventName = getMapScopedLeafletEventName(eventName);

            $scope.$on(eventName, handler);

            if (scopedEventName !== eventName) {
                // ui-leaflet prefixes events with the map id when the map has an id.
                $scope.$on(scopedEventName, handler);
            }
        }

        listenLeafletEvent('leafletDirectiveMap.contextmenu', function(event, args) {
            if (hasGeometryEditor()) {
                return;
            }

            if (!hasCoordinates()) {
                ctrl.contrat.lat = args.leafletEvent.latlng.lat;
                ctrl.contrat.lon = args.leafletEvent.latlng.lng;
                updateCoord();
            }
        });

        listenLeafletEvent('leafletDirectiveMap.click', function(event, args) {
            if (!hasGeometryEditor() || !ctrl.geometryPointCreationMode) {
                return;
            }

            addGeometryPoint(args.leafletEvent.latlng);
        });

        $scope.centerMap = function() {
            refreshCenter($scope.bounds);
        };

        $scope.deleteMarker = function() {
            ctrl.contrat.lat = null;
            ctrl.contrat.lon = null;
            ctrl.markerEditMode = false;
            refreshMap();
        };

        $scope.addMarker = function() {
            var agence = angular.copy(DEFAULT_AGENCE_POSITION);
            var account;

            if (hasCoordinates()) {
                return;
            }

            if (Principal.isIdentityResolved()) {
                account = Principal.getIdentityIfExist();

                if (account && account.agence && account.agence.lat && account.agence.lon) {
                    agence = account.agence;
                }
            }

            ctrl.contrat.lat = agence.lat;
            ctrl.contrat.lon = agence.lon;
            refreshMap();
        };

        $scope.editMarker = function() {
            $scope.addMarker();
            ctrl.markerEditMode = !ctrl.markerEditMode;
            refreshMap();
        };

        listenLeafletEvent('leafletDirectiveMarker.dragend', function(event, args) {
            var vertexMetadata = parseVertexMarkerName(args.modelName);

            if (vertexMetadata) {
                updateGeometryPoint(args.modelName, {
                    lat: args.model.lat,
                    lng: args.model.lng
                });
                return;
            }

            if (args.modelName === 'contrat') {
                ctrl.contrat.lat = args.model.lat;
                ctrl.contrat.lon = args.model.lng;
                refreshMap();
            }
        });

        listenLeafletEvent('leafletDirectiveMarker.click', function(event, args) {
            var vertexMetadata = parseVertexMarkerName(args.modelName);

            if (!vertexMetadata) {
                return;
            }

            ctrl.activeGeometryRing = {
                polygonIndex: vertexMetadata.polygonIndex,
                ringIndex: vertexMetadata.ringIndex
            };
        });

        $scope.$watchGroup([
            function() {
                return ctrl.contrat && ctrl.contrat.lat;
            },
            function() {
                return ctrl.contrat && ctrl.contrat.lon;
            },
            function() {
                return ctrl.contrat && getMarkerLabel();
            },
            function() {
                return getGeometryValue();
            },
            function() {
                return ctrl.markerEditMode;
            },
            function() {
                return ctrl.geometryEditMode;
            },
            function() {
                return ctrl.refreshToken;
            }
        ], function() {
            refreshMap();
        });
    }

    angular
        .module('wamasysApp')
        .component('mapLeaflet', mapLeaflet);
})();
